<template lang="pug">
    .subscription-topic.full-height-error.not-valid(v-if="!enabledExtensions.includes('newsletter')")
        Error(:message="null" :code="403")
    .subscription-topic.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    .subscription-topic.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .subscription-topic(v-else)
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                el-tooltip(v-if="! loading && isDeletable" class="item" effect="dark" :content="$t('Delete')" placement="top")
                    el-button.delete-button(
                        circle
                        type="danger"
                        icon="el-icon-fa-trash-alt far"
                        :loading="deleting"
                        :disabled="isDisabledSubmit && ! deleting"
                        @click="deleteCurrentSubscriptionTopic"
                    )
                el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="top")
                    el-button(
                        circle icon="el-icon-fa-times fas"
                        :disabled="isDisabledSubmit"
                        @click="leave"
                    )
                el-tooltip(v-if="! loading" class="item" effect="dark" :content="$t('Save and close')" placement="top")
                    el-button(
                        circle
                        type="primary"
                        icon="el-icon-fa-check fas"
                        :disabled="isDisabledSubmit && ! savingAndClose"
                        :loading="savingAndClose"
                        @click="submit($event, listRoute)"
                    )
                el-tooltip(v-if="! loading" class="item" effect="dark" :content="$t('Save')" placement="top")
                    el-button(
                        circle
                        type="success"
                        icon="el-icon-fa-save fas"
                        :disabled="isDisabledSubmit && ! saving"
                        :loading="saving"
                        @click="submit"
                    )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            all-input-fields
            el-card(shadow="always" v-loading="loading")
                router-view.subscription-topic-form(:key="$route.path" :class="{'loading-panel': loading}")
            .form-buttons
                el-button(
                    round v-if="! loading"
                    icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                ) {{ $t('Dismiss') }}
                el-button(
                    round v-if="! loading"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :loading="savingAndClose"
                    :disabled="isDisabledSubmit && ! savingAndClose"
                    @click="submit($event, listRoute)"
                ) {{ $t('Save and close') }}
                el-button(
                    round v-if="! loading"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :loading="saving"
                    :disabled="isDisabledSubmit && ! saving"
                    @click="submit"
                ) {{ $t('Save') }}
</template>

<i18n>
{
    "de": {
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Subscription Topic could not be fetched.": "Abonnement-Thema konnte nicht gefunden werden.",
        "Subscription Topic could not be deleted.": "Abonnement-Thema konnte nicht gelöscht werden.",
        "Subscription Topic deleted successfully!": "Abonnement-Thema erfolgreich gelöscht!",
        "Subscription Topic could not be saved.": "Abonnement-Thema konnte nicht gespeichert werden.",
        "Subscription Topic saved successfully!": "Abonnement-Thema erfolgreich gespeichert!",
        "Subscription Topic Not Found": "Abonnement-Thema nicht gefunden",
        "Subscription Topic": "Abonnement-Thema"
    }
}
</i18n>

<script>
import _ from 'lodash';

import router from '@/router';
import { useSetupStore, useNewsletterSubscriptionTopicStore } from '@/stores'

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';

// validate all fields, regardless if the corresponding component is mounted or not
import AllInputFields from './AllInputFields';

export default {
    name: 'SubscriptionTopic',
    data() {
        return {
            listRoute: { name: 'newsletter-subscription-topics' },
            error: false,
            pathNotValid: false,
            loading: false,
            saving: false,
            savingAndClose: false,
            deleting: false
        };
    },
    components: {
        Tabs,
        Error,
        AllInputFields
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.subscriptionTopicStore.setFormInitialized(false);
                this.initialize();
            }
        }
    },
    computed: {
        id() {
            return _.get(this.form, 'id', false);
        },
        isDeletable() {
            return !!this.id;
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.deleting;
        },
        // activeTab() {
        //     return _.replace(store.getters.activeTabKey, ':id', this.$route.params.id)
        // },
        tabs() {
            const id = this.$route.params.id;
            const name = _.get(this.form, 'name') || this.$t('Subscription Topic');

            return [
                {
                    name,
                    path: `/marketing/newsletter-subscription-topic/${id}/main`,
                    icon: {
                        name: 'list',
                        group: 'fas'
                    }
                }
            ];
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        subscriptionTopicStore() {
            return useNewsletterSubscriptionTopicStore();
        },
        form() {
            return this.subscriptionTopicStore.form;
        },
        options() {
            return this.subscriptionTopicStore.options;
        },
        initialized() {
            return this.subscriptionTopicStore.formInitialized;
        },
        validateOnEnter() {
            return this.subscriptionTopicStore.formValidateOnEnter;
        },
        rules() {
            return this.subscriptionTopicStore.rules;
        }
    },
    methods: {
        initialize() {
            if (!this.enabledExtensions.includes('newsletter')) {
                this.subscriptionTopicStore.setFormInitialized(true);
                return;
            }

            if (this.initialized !== true) {
                this.subscriptionTopicStore.setFormInitialized(true);

                const fetchDependencies = () =>
                    Promise.all([
                        // this.fetchSubscriptionTopicOptions(this.activeCms.id),
                        // this.fetchMenuOptions(this.activeCms.id),
                        // this.fetchTagOptions(this.activeCms.id),
                    ]);

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    this.subscriptionTopicStore.reset();
                    // this.subscriptionTopicStore.resetRules()

                    // fetchDependencies().then(() => this.subscriptionTopicStore.updateRules(rules))
                    fetchDependencies()
                        .then(() => {
                            this.subscriptionTopicStore.initializeSubscriptionTopic();
                            setTimeout(this.$refs.form.clearValidate, 0)
                        })
                        .catch(handleDependencyError)
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.subscriptionTopicStore.fetchSubscriptionTopic(this.$route.params.id)
                        .then(() => {
                            // this.subscriptionTopicStore.resetUI()

                            this.loading = false;

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    this.subscriptionTopicStore.resetRules();
                                    // this.subscriptionTopicStore.resetUI()
                                })
                                .catch(handleDependencyError)
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Subscription Topic Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Subscription Topic could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    // console.log('else');
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                // console.log('is already initialized');
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        deleteCurrentSubscriptionTopic() {
            this.deleting = true;
            this.subscriptionTopicStore.deleteSubscriptionTopic(this.id)
                .then(() => {
                    // this.deleting = false

                    router.push(this.listRoute);

                    this.$notify.success({
                        title: this.$t('Subscription Topic deleted successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.deleting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Subscription Topic could not be deleted.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        submit(event, redirect = false) {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    if (redirect) this.savingAndClose = true;
                    else this.saving = true;

                    let save = this.subscriptionTopicStore.create;
                    if (this.id) save = this.subscriptionTopicStore.update;

                    const isNew = this.$route.params.id === 'new';

                    save(this.form)
                        .then(() => {
                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;

                            this.$notify.success({
                                title: this.$t('Subscription Topic saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            // Replace URL with new ID after creating
                            if (isNew && this.id) {
                                const newPath = this.$route.path.replace('/new/', `/${this.id}/`);
                                router.replace(newPath);
                            }

                            if (redirect) router.push(redirect);
                        })
                        .catch(err => {
                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);

                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Subscription Topic could not be saved.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                } else {
                    this.subscriptionTopicStore.setFormValidateOnEnter(true);

                    // check the invalid fields
                    // and go to the corresponding tab
                    // or open the corresponding closed area
                    // TODO: scroll to invalid field

                    let invalidTabs = [];
                    _.each(errors, (error, path) => {
                        if (_.indexOf(['key', 'name'], path) >= 0) {
                            invalidTabs.push(`/marketing/subscription-topic/${this.$route.params.id}/main`);
                        }
                    });

                    invalidTabs = _.uniq(invalidTabs);

                    // check if the current tab
                    // is present in invalidTabs
                    // if not, go to next (first) invalid tab

                    const match = _.indexOf(invalidTabs, this.$route.fullPath);

                    // let switchTab = false;
                    if (match < 0) {
                        invalidTabs.every(invalidTab => {
                            if (invalidTab && this.activeTab !== invalidTab) {
                                const tab = _.find(this.tabs, { path: invalidTab });
                                if (tab) {
                                    this.activateTab(tab);

                                    // break loop after the first tab has been activated
                                    return false;
                                }
                            }
                        });
                    }

                    // // triger the validation again
                    // // so the previously hidden fields will get the errors
                    // // ---
                    // // does not work if the component has been destroyed
                    // // in the meantime (f.a. by switching tabs)
                    // if (switchTab === false) {
                    //     const form = this.$refs.form
                    //     setTimeout(() => {
                    //         form.validate(() => {
                    //             // do nothing
                    //             // callback function is required :(
                    //         })
                    //     }, 1000);
                    // }

                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        leave() {
            router.push(this.listRoute);
        },
        activateTab(item) {
            return useSetupStore().activateTab(item)
        }
    },
    mounted() {
        this.initialize();
    },
    beforeRouteEnter(to, from, next) {
        // let cms = _.get(store, 'state.setup.activeCms')

        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new';

        if (to.name === 'subscription-topic-form') {
            next({ name: 'subscription-topic-main', params: { id } });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        setTimeout(() => {
            this.subscriptionTopicStore.reset();
            this.subscriptionTopicStore.resetUI();
            this.$nextTick(() => this.subscriptionTopicStore.resetRules());
        }, 300);
    },
    destroyed() {
        // console.log('destroyed');
    }
};
</script>

<style lang="sass" scoped>
.subscription-topic:deep()
    .el-card__body
        padding: 0
        & > section
            padding: 20px
</style>
